import { render, staticRenderFns } from "./help-bar.vue?vue&type=template&id=94ca683e&scoped=true"
import script from "./help-bar.vue?vue&type=script&lang=js"
export * from "./help-bar.vue?vue&type=script&lang=js"
import style0 from "./help-bar.vue?vue&type=style&index=0&id=94ca683e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ca683e",
  null
  
)

export default component.exports